import { SHOW_SNACKBAR } from "./types";
 

export const showSnackBar = (message = null, severity = "", open = true) => ({
  type: SHOW_SNACKBAR,
  payload: { message, severity, open },
});
